import { Navigate } from 'react-router-dom';
import { config } from '../../config/config';
import MaintenanceMessage from '../Maintenance/MaintenanceMessage';

interface AuthGuardProps {
    children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
    if (!config.FEATURES.AUTH_ENABLED) {
        return <MaintenanceMessage />;
    }

    return <>{children}</>;
};

export default AuthGuard; 